import React from 'react';

import TopPanel from '../../../../components/utils/TopPanel';

type Props = {
  goBack(): void;
  name: string;
  onSave?(): void;
  disabled?: boolean;
};

const Header = ({ goBack, name, onSave, disabled }: Props) => {
  return (
    <TopPanel isDetailsPage>
      <div
        role='button'
        className='btn-nav back'
        onClick={goBack}
        style={{ marginLeft: '40px' }}
      >
        <i className='fas fa-arrow-left' style={{ paddingRight: '8px' }} />
        <span className='page-back'>Back</span>
        <span className='page-back-mobile'>{name}</span>
      </div>
      {onSave && (
        <div className='page-actions'>
          <button
            type='button'
            disabled={disabled}
            onClick={onSave}
            className='btn btn-primary pull-right'
          >
            Save
          </button>
        </div>
      )}
    </TopPanel>
  );
};
export default Header;
